export const APP_VERSION = process.env.REACT_APP_BUILD_VERSION || "dev";
export const UI_HASH = process.env.REACT_APP_UI_HASH || null;
